import _regeneratorRuntime from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import { getRawContent } from "./file.js";
import { isNodeReadableStream, isWebReadableStream } from "./typeGuards.js";
/**
 * Drain the content of the given ReadableStream into a Blob.
 * The blob's content may end up in memory or on disk dependent on size.
 */

function drain(stream) {
  return new Response(stream).blob();
}

function toBlobPart(_x) {
  return _toBlobPart.apply(this, arguments);
}
/**
 * Utility function that concatenates a set of binary inputs into one combined output.
 *
 * @param sources - array of sources for the concatenation
 * @returns - in Node, a (() =\> NodeJS.ReadableStream) which, when read, produces a concatenation of all the inputs.
 *           In browser, returns a `Blob` representing all the concatenated inputs.
 *
 * @internal
 */


function _toBlobPart() {
  _toBlobPart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
    var rawContent;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(source instanceof Blob || source instanceof Uint8Array)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", source);

          case 2:
            if (!isWebReadableStream(source)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", drain(source));

          case 4:
            // If it's not a true Blob, and it's not a Uint8Array, we can assume the source
            // is a fake File created by createFileFromStream and we can get the original stream
            // using getRawContent.
            rawContent = getRawContent(source); // Shouldn't happen but guard for it anyway

            if (!isNodeReadableStream(rawContent)) {
              _context.next = 7;
              break;
            }

            throw new Error("Encountered unexpected type. In the browser, `concat` supports Web ReadableStream, Blob, Uint8Array, and files created using `createFile` only.");

          case 7:
            return _context.abrupt("return", toBlobPart(rawContent));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _toBlobPart.apply(this, arguments);
}

export function concat(_x2) {
  return _concat.apply(this, arguments);
}

function _concat() {
  _concat = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(sources) {
    var parts, _iterator, _step, source;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            parts = [];
            _iterator = _createForOfIteratorHelper(sources);
            _context2.prev = 2;

            _iterator.s();

          case 4:
            if ((_step = _iterator.n()).done) {
              _context2.next = 13;
              break;
            }

            source = _step.value;
            _context2.t0 = parts;
            _context2.next = 9;
            return toBlobPart(typeof source === "function" ? source() : source);

          case 9:
            _context2.t1 = _context2.sent;

            _context2.t0.push.call(_context2.t0, _context2.t1);

          case 11:
            _context2.next = 4;
            break;

          case 13:
            _context2.next = 18;
            break;

          case 15:
            _context2.prev = 15;
            _context2.t2 = _context2["catch"](2);

            _iterator.e(_context2.t2);

          case 18:
            _context2.prev = 18;

            _iterator.f();

            return _context2.finish(18);

          case 21:
            return _context2.abrupt("return", new Blob(parts));

          case 22:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 15, 18, 21]]);
  }));
  return _concat.apply(this, arguments);
}